import { getTickerVal } from './calculateTotalAssets';
import { UserPnLExpectedData } from '../modules/user/assets/types';

export const calcPnlExpected = async (totalVolume: UserPnLExpectedData[]) => {
    let totalPercent = 0;
    let totalPnl = 0;
    let totalValueAll = 0;
    for (const ticker in totalVolume) {
        if (totalVolume.hasOwnProperty(ticker)) {
            const data = totalVolume[ticker];
            const tickerName = Object.keys(data)[0];
            const tickerInfo = data[tickerName];
            const tickerVal = await getTickerVal(tickerName);
            // totalPercent =
            //     totalPercent + (tickerVal * tickerInfo.totalAmount - tickerInfo.totalValue) / tickerInfo.totalValue;
            totalPnl = totalPnl + (tickerVal * tickerInfo.totalAmount - tickerInfo.totalValue);
            totalValueAll += tickerInfo.totalValue;
        }
    }
    totalPercent = (totalPnl / totalValueAll) * 100;
    return { totalPercent, totalPnl };
};
